// Config & Enviroment constants
export const APIVersion = 'v1';
export const AuthAPIVersion = 'v1';
export const AuthAPIPrefix = 'auth_api';
export const APIPrefix = 'api';
export const SolrAPIPrefix = '/solr';
export const DataAPIPrefix = '';
export const API_BASE = `/${APIPrefix}/${APIVersion}`; // /api/v1
export const AUTH_API_BASE = `/${AuthAPIPrefix}/${AuthAPIVersion}`; // /auth_api/v1
export const MANAGEMENT_HOST_DEV = 'https://management.dev.silal.app';
export const SELLER_HOST_DEV = 'https://seller.dev.silal.app';
export const BUYER_HOST_DEV = 'https://www.dev.silal.app';
export const SHARED_HOST_DEV = 'https://shared.dev.silal.app';
export const DATA_HOST_DEV = 'https://data.dev.silal.app';
export const SEARCH_HOST_DEV = 'https://search.dev.silal.app';
export const IMAGE_STORE_HOST_DEV =
  'development-image-store-silal.s3.eu-central-1.amazonaws.com';
export const IMAGE_CDN_HOST_DEV = 'silal-dev.b-cdn.net';

export const MANAGEMENT_HOST_PROD = 'https://management.api.silal.app';
export const SELLER_HOST_PROD = 'https://seller.api.silal.app';
export const BUYER_HOST_PROD = 'https://www.api.silal.app';
export const SHARED_HOST_PROD = 'https://shared.api.silal.app';
export const DATA_HOST_PROD = 'https://data.api.silal.app';
export const SEARCH_HOST_PROD = 'https://search.api.silal.app';
export const IMAGE_STORE_HOST_PROD =
  'production-image-store-silal.s3.eu-central-1.amazonaws.com';
export const IMAGE_CDN_HOST_PROD = 'cdn.silal.app';

export const ENVIROMENT_TYPE = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
};

export const USER_TYPE = {
  Management: 'management',
  Seller: 'seller',
  Buyer: 'buyer',
  Shared: 'shared',
  Solr: 'solr',
  Data: 'data',
};

// Local Storage
export const LOCAL_STORAGE_TOKEN_KEY = 'sl-token';

// Allowed MIME Types
export const ALLOWED_MIME_TYPES = [
  'image/avif',
  'image/apng',
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/webp',
  'avif',
  'apng',
  'bmp',
  'gif',
  'jpeg',
  'png',
  'svg+xml',
  'webp',
];

// Regex
export const arabicRegx = /^[\u0600-\u06FF\s0-9 ،.",.'\-\\&]+$/;
export const englishRegx = /^[a-zA-Z\s0-9 ،.",.'\-\\&]+$/;
export const numbersRegx = /^[0-9]+$/;

// Localization constants:
export const CURRENCY_SYMBOL = {
  USD: '$',
  EUR: '€',
  ILS: '₪',
};
export const CURRENT_CURRENCY = CURRENCY_SYMBOL.ILS;

export const ISRAEL_TIMEZONE = 'Asia/Jerusalem';
export const UTC = 'UTC';
export const DateTimeFormat = 'YYYY-MM-DD HH:mm';
export const DateTimeServerFormat = 'YYYY-MM-DD HH:mm:ss';
export const DateTimeFormatDateOnly = 'YYYY-MM-DD';
export const DateTimeFormatHoursMinutesOnly = 'HH:mm';
export const DateTimeFormateLeftToRight = 'HH:mm DD/MM/YY';
export const DateTimeFormateLeftToRightWithSeconds = 'HH:mm:ss DD/MM/YY';

// Auth Constants
export const OTP_EXPIRATION_TIME_IN_SECONDS = 90;
export const EMAIL_OTP_EXPIRATION_TIME_IN_SECONDS = 300;

export const PHONE_OTP_CODE_LENGTH = 5;
export const EMAIL_OTP_CODE_LENGTH = 6;

// Images Constants
export const SHOW_IMAGE_CONSTANTS = {
  IMAGE_HEIGHT: '150px',
  IMAGE_WIDTH: '200px',
};

// Location Constants
export const DefaultLocationCoords = {
  lat: '31.778000',
  lng: '35.235400',
};

// Listings Constants
export const LISTING_TYPES = {
  public_listing: 1,
  draft: 2,
  template: 3,
};

export const LISTING_TYPES_NAME = {
  1: 'public_listing',
  2: 'draft',
  3: 'template',
};

export const LISTING_STATUS = {
  changed: 300,
  unknown: 0,
  draft: 1,
  template: 2,
  pending_review: 3,
  rejected: 4,
  approved: 5,
  freezed_by_management: 6,
  freezed_by_seller: 7,
  category_hidden: 8,
  listed: 9,
  has_newer_version: 10,
};

export const LISTING_STATUS_TYPES = {
  300: 'Changed',
  0: 'Unknown',
  1: 'Draft',
  2: 'Template',
  3: 'Pending Review',
  4: 'Rejected',
  5: 'Approved',
  6: 'Management Freeze',
  7: 'Seller Freeze',
  8: 'Category Hidden',
  9: 'Listed',
  10: 'Old Version',
};

export const LISTING_STATUS_COLORS = {
  300: '#AAAAAA', // Black for Unknown
  0: '#000000', // Black for Unknown
  1: '#A9A9A9', // Dark Gray for Draft
  2: '#FFA500', // Orange for Template
  3: '#00CED1', // Dark Turquoise for Pending Review
  4: '#FF0000', // Red for Rejected
  5: '#008000', // Green for Approved
  6: '#800080', // Purple for Freezed by Management
  7: '#9932CC', // Dark Orchid for Freezed by Seller
  8: '#4B0082', // Indigo for Category Hidden
  9: '#2E8B57', // Sea Green for Listed
  10: '#FFD700', // Gold for Has Newer Version
};

export const SELLER_REQUEST_TYPES = {
  seller_management_add_store: 4,
  seller_management_add_listing: 5,
};

// Store Constants
export enum StoreRequestsStatus {
  All,
  Pending,
  Rejected,
  Accepted,
}

// Formatting Constants
export const NUMBER_OF_ZEROS_TO_HIDE_FROM_THE_END = 4;

// Payment Constants
export const CURRENT_VAT = 0.17;

// DEFAULT_CITY (JERUSALEM ID
export const DEFAULT_CITY = 1;

// APP LINKS
export const APP_LINKS = {
  buyer: {
    ios: `https://apps.apple.com/il/app/silal-buyer/id6496847430`,
    android: `https://play.google.com/store/apps/details?id=app.silal.buyer.prod`,
    app_name: 'Silal | سِلال',
    package: 'app.silal.buyer.prod',
    app_store_id: '6496847430',
  },
  policies: {
    terms_of_service_and_privacy_policy:
      'https://go.silal.app/terms-of-use-and-privacy-browser',
  },
};
